export enum LoginMode {
  NO_PASSWORD = "no_password",
  COMMON_PASSWORD = "common_password",
  INDIVIDUAL_PASSWORD = "individual_password"
}